import { useNavigate, useLocation } from 'react-router-dom';
import { isOurDomain } from '~/utils/navigation';

export const useGoBack = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const thereIsAPrevPage = location.key !== 'default';
  const isArtPage = location.pathname.includes('/art/');

  // Check if we have a safe "from" location in state
  const fromLocation = location.state?.from;
  const hasValidFromLocation = fromLocation && isOurDomain(fromLocation);

  // Check document referrer
  const referrer = document.referrer;
  const referrerIsOurs = referrer && isOurDomain(referrer);

  // Whether state.from points back to an art page (e.g. /art/123)
  const fromLocationIsArtPage = hasValidFromLocation && fromLocation.includes('/art/');

  return ({ fallback }: { fallback?: string } = {}) => {
    if (isArtPage) {
      navigate(fallback || '/my-artwork');
    } else if (hasValidFromLocation && !fromLocationIsArtPage) {
      // Navigate to a specific non-art location recorded in state
      navigate(fromLocation);
    } else if (thereIsAPrevPage && referrerIsOurs) {
      // Use browser history. This also covers fromLocation pointing to an art page:
      // navigate(-1) restores the art page with its original history state, so its
      // own close button can continue navigating correctly (e.g. back to /my-artwork).
      navigate(-1);
    } else if (hasValidFromLocation) {
      // fromLocation is an art page but no browser history entry exists — navigate directly
      navigate(fromLocation);
    } else {
      // No safe history, use fallback
      navigate(fallback || '/');
    }
  };
};
